/**
 * Passport country presets — separate from resize catalog.
 * Endpoint: GET /api/passport-presets
 */
import apiClient from "../client";

/**
 * @param {Object} [options]
 * @param {boolean} [options.dashboardOnly]
 * @param {boolean} [options.grouped=true] - wrap in category_id=2 group (legacy UI)
 */
export const getPassportPresets = async (options = {}) => {
  const params = {};
  if (options.dashboardOnly) {
    params.dashboard_only = true;
  }
  if (options.grouped === false) {
    params.grouped = false;
  }
  const response = await apiClient.get("/api/passport-presets", { params });
  return response.data;
};

export default { getPassportPresets };
